'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _packagesConfigs = require('../../containers/RealtorPackagesContainer/packagesConfigs');








var _components = require('../../components');

var _RealtorPackage = require('./RealtorPackage.scss');var styles = _interopRequireWildcard(_RealtorPackage);
var _paymentCalculation = require('../../helpers/paymentCalculation');
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // styles
var
RealtorPackage = function (_Component) {_inherits(RealtorPackage, _Component);
  function RealtorPackage(props) {_classCallCheck(this, RealtorPackage);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.














    handleChoosePackage = function () {return _this.props.handleChoosePackage(_this.props.packageInstance);};_this.

    changePeriod = function (value) {var _this$props =
      _this.props,packageInstance = _this$props.packageInstance,isCalculator = _this$props.isCalculator,changePackagesPeriod = _this$props.changePackagesPeriod;
      var selectedPeriod = _packagesConfigs.realtorPackagePeriods.find(function (item) {return item.value === +value;});

      packageInstance.changePeriod(selectedPeriod);

      if (isCalculator) {
        changePackagesPeriod(selectedPeriod);
      }

      _this.forceUpdate();
    };_this.

    renderFeature = function (feature) {var _cx;var _this$props2 =
      _this.props,translate = _this$props2.translate,packageInstance = _this$props2.packageInstance;
      var featuresData = packageInstance.features;
      var value = featuresData[feature];
      var status = !!value ? _RealtorLanding2.default.checkMark : _RealtorLanding2.default.cross;
      var xCount = !!value && typeof value === 'number' ? 'x' + value : '';

      return (
        _react2.default.createElement('div', {
            key: packageInstance.id + '_' + feature,
            className: (0, _classnames2.default)(styles.featureItem, (_cx = {}, _cx[styles.disabledFeature] = !value, _cx)) },

          !xCount ?
          _react2.default.createElement('img', { src: status, alt: '' }) :
          _react2.default.createElement('p', null, value),

          !xCount ?
          _react2.default.createElement('span', { className: 'icon icon-' + status },
            _react2.default.createElement('i', { className: 'path1' }),
            _react2.default.createElement('i', { className: 'path2' }),
            _react2.default.createElement('i', { className: 'path3' })) :

          ''));



    };_this.

    renderPriceItem = function (label, data, isBold) {var _cx2;return (
        _react2.default.createElement('div', { className: styles.priceItem },
          _react2.default.createElement('span', null, '' + _this.props.translate('packages', label), '\xA0'),
          _react2.default.createElement('span', { className: (0, _classnames2.default)((_cx2 = {}, _cx2[styles.boldText] = isBold, _cx2)) }, '\u200E', data)));};_this.



    renderDiscount = function (bonusAmount) {var _this$props3 =
      _this.props,translate = _this$props3.translate,packageInstance = _this$props3.packageInstance;

      var totalAmount = (0, _beautifyNumber2.default)(packageInstance.pricePerMonth - bonusAmount);
      var bonus = _this.renderPriceItem('benefit', '- \u20AA ' + bonusAmount);
      var totalPrice = _this.renderPriceItem('total', '\u20AA ' + totalAmount, true);
      return (
        _react2.default.createElement('div', null,
          bonus,
          totalPrice));


    };_this.
































    renderPackageMobile = function () {var _cx3;var _this$props4 =
      _this.props,packageInstance = _this$props4.packageInstance,discountCoupon = _this$props4.discountCoupon;
      var translate = _this.props.translate('packages');
      var bonusAmount = !!discountCoupon && (0, _paymentCalculation.getCouponBonus)(
      packageInstance.pricePerMonth,
      discountCoupon,
      packageInstance.legacyPackageDescription);

      // const titlePrice = packageInstance.titlePrice;
      var properties = packageInstance.features.properties;

      return (
        _react2.default.createElement('div', { className: styles.packageMobileWrapper },
          _react2.default.createElement('p', { className: styles.packageTitle }, properties),
          _react2.default.createElement('div', { className: styles.packagePriceWrapper },
            _react2.default.createElement('div', { className: styles.prices },
              _packagesConfigs.PACKAGE_FEATURES_ORDER.map(function (item) {return _react2.default.createElement('p', { key: item }, translate(item));})),

            _react2.default.createElement('div', { className: styles.packageFeatures },
              _packagesConfigs.PACKAGE_FEATURES_ORDER.map(_this.renderFeature))),


          _react2.default.createElement('div', { className: styles.packageSwitch },
            _react2.default.createElement('p', { className: styles.stock }, translate('stock_1')),
            _react2.default.createElement(_components.HomePagePropertiesChips, {
              name: packageInstance.id + '_switch',
              values: _this.state.formattedPackagePeriods,
              selectedValue: packageInstance.currentPeriodValue.toString(),
              onChange: _this.changePeriod,
              className: 'switcherMobile' }),

            _react2.default.createElement('div', { className: styles.switcherDescription },
              _react2.default.createElement('div', null,
                _react2.default.createElement('p', null, _this.props.isRtl && _react2.default.createElement('span', null, translate('spin')))),

              _react2.default.createElement('p', null, translate('stock_2')))),


          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.price, (_cx3 = {}, _cx3[styles.withDiscount] = !!bonusAmount, _cx3)) },
            _react2.default.createElement('div', null,
              _react2.default.createElement('div', { className: styles.oldPrice },
                isNaN(packageInstance.oldPricePerMonth) ? '' : _react2.default.createElement('p', null, packageInstance.oldPricePerMonth, ' \u20AA')),

              _react2.default.createElement('span', null, packageInstance.pricePerMonth), ' \u20AA ', translate('perMonth')))));




    };_this.state = { locale: _this.props.locale, formattedPackagePeriods: (0, _packagesConfigs.getFormattedRealtorPackagePeriods)(props.translate('packages')) };return _this;}RealtorPackage.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (nextProps.locale !== this.props.locale) {this.setState({ formattedPackagePeriods: (0, _packagesConfigs.getFormattedRealtorPackagePeriods)(nextProps.translate) });}};RealtorPackage.prototype.renderPriceBlock = function renderPriceBlock() {var _cx4;var _props = this.props,packageInstance = _props.packageInstance,discountCoupon = _props.discountCoupon;var translate = this.props.translate('packages');var bonusAmount = !!discountCoupon && (0, _paymentCalculation.getCouponBonus)(packageInstance.pricePerMonth, discountCoupon, packageInstance.legacyPackageDescription, []);var properties = packageInstance.features.properties; // const titlePrice = packageInstance.titlePrice;
    var totalAmount = !!bonusAmount && (0, _beautifyNumber2.default)(packageInstance.pricePerMonth - bonusAmount);return _react2.default.createElement('div', { className: styles.priceBlock }, _react2.default.createElement('div', null, _react2.default.createElement('p', { className: styles.priceTitle }, properties), _react2.default.createElement('div', { className: styles.priceWrapper }, _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.price, (_cx4 = {}, _cx4[styles.withDiscount] = !!bonusAmount, _cx4)) }, _react2.default.createElement('div', { className: styles.oldPrice }, isNaN(packageInstance.oldPricePerMonth) ? '' : _react2.default.createElement('p', null, packageInstance.oldPricePerMonth, ' \u20AA')), _react2.default.createElement('span', null, packageInstance.pricePerMonth), ' \u20AA ', translate('perMonth'))), !!bonusAmount && _react2.default.createElement('div', { className: styles.price }, '\u20AA', Math.round(totalAmount))), _react2.default.createElement('div', { className: styles.priceBorder }));};RealtorPackage.prototype.
  render = function render() {
    var translate = this.props.translate('packages');

    if (this.state.locale !== this.props.locale) {
      this.setState({
        formattedPackagePeriods: (0, _packagesConfigs.getFormattedRealtorPackagePeriods)(this.props.translate('packages')),
        locale: this.props.locale });

    }

    return (
      _react2.default.createElement('div', { className: styles.packageWrapper },
        _react2.default.createElement('div', { className: styles.priceBlockWrapper },
          this.renderPriceBlock(),
          _react2.default.createElement('div', { className: styles.packageFeatures },
            _packagesConfigs.PACKAGE_FEATURES_ORDER.map(this.renderFeature))),


        this.renderPackageMobile(),
        _react2.default.createElement('button', {
            onClick: this.handleChoosePackage,
            className: styles.actionButton },

          translate('choosePlan'))));



  };return RealtorPackage;}(_react.Component);


RealtorPackage.propTypes = {
  locale: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  packageInstance: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  changePropertiesCount: _propTypes2.default.func,
  changePackagesPeriod: _propTypes2.default.func,
  handleChoosePackage: _propTypes2.default.func,
  isCalculator: _propTypes2.default.bool,
  discountCoupon: _propTypes2.default.string };exports.default =


RealtorPackage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorPackage/RealtorPackage.js
// module id = 2888
// module chunks = 0